"use client";

import React from "react";
import { WcWebUiContextType, WcWebuiProvider } from "@bpipartners/webui";
import { Theme, useTheme } from "@guberno/utils/theme";
import { useTranslations } from "next-intl";

export const WebuiClientWrapper = ({ children }: any) => {
  const t = useTranslations();
  const theme = useTheme();

  const webuiProps: WcWebUiContextType = {
    mode: "light",
    t: t,
    useTheme: () => theme,
    dateLocaleConfig: {
      locale: "nl",
      startOfWeek: 1,
    },
  };

  return (
    <WcWebuiProvider
      mode="light"
      t={webuiProps.t}
      useTheme={useTheme as () => Theme}
      dateLocaleConfig={{
        locale: "nl",
        startOfWeek: 1,
      }}
    >
      {children}
    </WcWebuiProvider>
  );
};
